import { render } from "./InviteModal.vue?vue&type=template&id=65f5aa62&scoped=true"
import script from "./InviteModal.vue?vue&type=script&lang=js"
export * from "./InviteModal.vue?vue&type=script&lang=js"

import "./InviteModal.vue?vue&type=style&index=0&id=65f5aa62&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f5aa62"]])

export default __exports__